<div class="container-fluid justify-content-center h-100 d-flex flex-column">
  <div class="row justify-content-center px-4">
    <mat-card class="callback-card col-12 col-md-8 col-lg-6 col-xl-5 p-5">
      <mat-card-content class="d-flex flex-column">
        <h1 class="mb-2">{{'general.app_name' | translate}}</h1>

        <!-- Processing State -->
        @if (processing) {
        <div class="loading-container text-center py-4">
          <mat-spinner diameter="40" class="mb-3"></mat-spinner>
          <h2>{{ 'auth.processing_login' | translate }}</h2>
          <p class="mb-0">{{ 'auth.please_wait' | translate }}</p>
        </div>
        }

        <!-- Error State -->
        @if (!processing && errorMessage) {
        <div class="error-container py-4">
          <mat-error class="mb-3">
            <mat-icon>error</mat-icon>
            {{ errorMessage }}
          </mat-error>
          <p class="redirect-message text-center">
            <mat-icon class="me-1">schedule</mat-icon>
            {{ 'auth.redirecting_to_login' | translate }}
          </p>
        </div>
        }
      </mat-card-content>
    </mat-card>
  </div>
</div>